var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserselcted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(-48 -201.76)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 24,
    height: 24,
    transform: "translate(48 201.76)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "profile-2user",
    transform: "translate(50.999 201.761)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M4.25,6.75a4.733,4.733,0,0,0,4.63,4.74.807.807,0,0,1,.22,0h.07A4.747,4.747,0,1,0,4.25,6.75Z",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M3.931,14.149a3.947,3.947,0,0,0-1.97,3.23,3.914,3.914,0,0,0,1.96,3.21A9.239,9.239,0,0,0,9,22a9.239,9.239,0,0,0,5.08-1.41,3.945,3.945,0,0,0,1.96-3.23,3.937,3.937,0,0,0-1.96-3.21A9.929,9.929,0,0,0,3.931,14.149Z",
    fill: "#15345a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserselcted);
export default __webpack_public_path__ + "static/media/userselcted.19d1a5a7b9c4855ddd4d2e996f30ec3b.svg";
export { ForwardRef as ReactComponent };